import { MasterFixture } from "./all";

export const RoutePutInputsMasterFixtures_masterFixtureId_ =
  "/inputs/master-fixtures/:masterFixtureId";

export type ParamsPutInputsMasterFixtures_masterFixtureId_ = {
  masterFixtureId: string;
};

export type PayloadPutInputsMasterFixtures_masterFixtureId_ = {
  maxShelfHeight: number;
  maxProductHead: number;
};

export type ResponsePutInputsMasterFixtures_masterFixtureId_ = MasterFixture;
